module.exports = __webpack_public_path__ + "img/green-tick.60e43e24.png";